export default class AgentApp {
  response=null;
  currentReader=null;
  static ins=null;
  static getInstance(){
    if(AgentApp.ins==null){
      AgentApp.ins=new AgentApp();
    }
    return AgentApp.ins;
  }
  async onChart(url,data,callback_content,callback_reasoning){
    try {
      // 1. 发送 POST 请求，建立 SSE 连接
      this.response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (!this.response.ok) {
        throw new Error('请求失败');
      }

      // 2. 获取响应流的读取器
      this.currentReader = this.response.body.getReader();
      const decoder = new TextDecoder('utf-8');

      // 3. 循环读取流式数据
      while (true) {
        const { done, value } = await this.currentReader.read();
        if (done) break;

        // 4. 解析 SSE 格式的数据
        const chunk = decoder.decode(value);
        // 按行分割（SSE 每段数据以 \n\n 分隔）
        const lines = chunk.split('\n\n');

        for (let line of lines) {

          if(line.startsWith('data: [c-]')){
            // 提取 data: 后面的内容
            let _data = line.replace("data: [c-]", '');
            if (_data === '[DONE]') {
              // 流结束
              continue;
            }

            if(_data!==null && _data!==undefined&&_data.length>0){

              let data2="";
              try {
                data2=(JSON.parse(_data)).data||""
              }catch (e) {
                console.error('解析数据失败：', _data)
              }

              try {
                typeof callback_content === 'function' && callback_content(data2);
              } catch (e) {
                console.error('解析数据失败：', e);
              }
            }


          }else {
            let _data = line.replace("data: [r-]", '');
            if (_data === '[DONE]') {
              // 流结束
              continue;
            }
            if(_data!==null && _data!==undefined&&_data.length>0){
              // 提取 data: 后面的内容

              let data2="";
              try {
                data2=(JSON.parse(_data)).data||""
              }catch (e) {
                console.error('解析数据失败：', _data)
              }


              try {
                typeof callback_reasoning === 'function' && callback_reasoning(data2);
              } catch (e) {
                console.error('解析数据失败：', e);
              }
            }

          }

        }
      }

    } catch (error) {
      console.log(error)
    } finally {
      // 恢复输入和按钮
      // 清理资源 + 恢复界面状态
      if (this.currentReader) {
        // 取消读取器（核心：关闭流连接）
        await this.currentReader.cancel('用户主动取消');
        this.currentReader = null;
      }
    }
  }
  async cancel(){
    if (this.currentReader) {
      // 取消读取器（核心：关闭流连接）
      await this.currentReader.cancel('用户主动取消');
      this.currentReader = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/Admin/Butler/common/AgentApp.js